module.exports = __webpack_public_path__ + "img/user_more_icon_black.29fe6254.svg";